"use client";

import React from "react";
import { Video, PenTool, Smartphone, Sparkles } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const specialties = [{
  title: "Digital Literacy & Technology Education",
  description: "We help children and young people develop practical skills in coding, AI, digital tools and creative technology.",
  icon: Smartphone
}, {
  title: "Community Learning Programs",
  description: "We support learning opportunities that encourage confidence, participation and personal growth.",
  icon: Sparkles
}, {
  title: "Youth Skills Development",
  description: "We create programs that help young people explore future pathways, problem-solving and innovation.",
  icon: PenTool
}, {
  title: "Partners & Community Projects",
  description: "We work with schools, councils, community groups and local organisations to deliver meaningful education initiatives.",
  icon: Video
}];
export default function EmpoweringThroughEducation() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="239334" id="empowering-through-education" className="dark bg-background text-foreground py-24 px-6 md:px-12 overflow-hidden relative">
      {}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1682293/img/grid-me.png')]" />
      
      <div className="max-w-7xl mx-auto relative z-10">
        <div ref={ref} className={`text-center mb-16 transition-all duration-700 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-default text-4xl md:text-5xl font-bold mb-6 tracking-tight text-primary">
            What We Do
          </h2>
          <p className="font-default text-lg text-muted-foreground max-w-2xl mx-auto">
            Future Ready Australia Ltd offers four core programs designed to create accessible, practical learning opportunities that build confidence and digital capability.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {specialties.map((specialty, i) => {
          const Icon = specialty.icon;
          return <div key={specialty.title} data-index={i} className={`transition-all duration-700 delay-[${i * 100}ms] transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
            transitionDelay: `${i * 100}ms`
          }}>
                <Card className="h-full bg-card border-border/50 transition-all duration-300 hover:-translate-y-2 hover:shadow-xl group cursor-default rounded-2xl">
                  <CardHeader className="flex flex-col items-center text-center pt-10 pb-4">
                    <div className="mb-6 p-4 rounded-lg bg-primary/10 group-hover:bg-primary/20 transition-colors duration-300">
                      <Icon className="w-16 h-16 text-primary stroke-[2]" />
                    </div>
                    <CardTitle className="font-default text-2xl font-bold tracking-wide text-primary">
                      {specialty.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="text-center pb-10">
                    <p className="font-default text-[18px] leading-snug text-muted-foreground group-hover:text-foreground transition-colors duration-300">
                      {specialty.description}
                    </p>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}